module.exports = __webpack_public_path__ + "static/img/4.0216893.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-cn/4.jpg
// module id = n5Et
// module chunks = 1